<template>
  <q-form class="license-state-dialog-container center relative scroller">
    <div class="row items-center icon-container">
      <img
        :src="License_exclamation_icon"
        alt="License-exclamation-icon"
      />
    </div>
    <div class="dialog-title text-center">{{ $t('generic.licenseStates.licenseOccupied.title') }}</div>
    <div class="dialog-description text-center">
      <div class="gordita-400-16-r">{{ $t('generic.licenseStates.licenseOccupied.description') }}</div>

      <div class="input-container">
        <q-input
          :data-testid="elementsId.dialogs.licenseDialogs.licenseOccupiedDialog.licenseKeyInput"
          class="license-key-input"
          label="Enter a different license key"
          v-model="licenseKey"
          bg-color="white"
          outlined
          lazy-rules
          input-class="brand_almost_black"
          no-error-icon
          @keypress="handleKeyPress($event)"
        />
      </div>

      <div class="button-container">
        <q-spinner-dots
          v-if="licensePending"
          class="text-brand_almost_black"
          style="align-items: center"
          size="4em"
        />
        <q-btn
          :data-testid="elementsId.dialogs.licenseDialogs.licenseOccupiedDialog.submitButton"
          v-else
          ref="sumbit-button"
          flat
          type="submit"
          rounded
          no-caps
          tabindex="3"
          :disabled="!licenseKey"
          :class="{ disabled: !licenseKey }"
          class="submit-button load-key-btn incredi-button-ibx primary-strong enable focus-be-gone"
          :label="$t('generic.licenseStates.loadKey')"
          @click.prevent.stop="submitLicense()"
        />
      </div>
    </div>

    <div class="dialog-footer text-center">
      <span class="gordita-regular-14 footer-text">For assistance, contact </span>
      <a
        class="gordita-500-14-m text-brand_almost_black"
        :href="supportMailUrl"
        >{{ supportMailUrl.split(':')[1] }}</a
      >
    </div>
  </q-form>
</template>

<script>
import elementsId from '@/const/elementIds.json';
import { defineComponent } from 'vue';
import License_exclamation_icon from '../../../../assets/images/LicenseStatesDialogs/license-exclamation-icon.svg';
import { licenseDialogMixins } from './licenseDialogMixins';

export default defineComponent({
  name: 'LicenseOccupiedDialog',
  mixins: [licenseDialogMixins],
  setup() {
    return {
      License_exclamation_icon,
      elementsId,
    };
  },
});
</script>

<style scoped lang="scss">
@import './LicenseDialogsCommonStyle';
</style>
